<div class="progressTracker mb-5">
    <div class="row mb-3">
        <div class="col-12 backBtn" [ngClass]="isArabic ? 'arabicAlign' : ''">
            <button class="btn-lg btn-primary ratButton rightBtn" (click)="goToLastPage()">
                <span *ngIf="!isArabic">back</span>
                <span *ngIf="isArabic">العودة</span>
            </button>
        </div>
        <div class="col-12" [ngClass]="isArabic ? 'arabicAlign' : ''">
            <label class="assessmentName">{{progressDetails?.assessmentName}}</label>
        </div>
    </div>
    <div class="row mb-4" [ngClass]="isArabic ? 'arabicAlign' : ''">
        <div class="col-3 mainBox">
            <div class="row mainInnerBox" [ngClass]="isArabic ? 'arabicAlign' : ''">
                <div class="col-7 labelName" [ngClass]="isArabic ? 'arabicLabelAlign' : ''">
                    <span *ngIf="!isArabic">Total Questions</span>
                    <span *ngIf="isArabic">مجموع الأسئلة</span>
                </div>
                <div class="col-5 numbers" [ngClass]="isArabic ? 'arabicNumberAlign' : ''">
                    <div class="innerBox">
                        <span>{{progressDetails?.totalQuestions}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 mainBox">
            <div class="row mainInnerBox" [ngClass]="isArabic ? 'arabicAlign' : ''">
                <div class="col-7 labelName" [ngClass]="isArabic ? 'arabicLabelAlign' : ''">
                    <span *ngIf="!isArabic">Not Answered</span>
                    <span *ngIf="isArabic">لم يتم الإجابة</span>
                </div>
                <div class="col-5 numbers" [ngClass]="isArabic ? 'arabicNumberAlign' : ''">
                    <div class="innerBox">
                        <span>{{progressDetails?.notAnswered}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 mainBox">
            <div class="row mainInnerBox" [ngClass]="isArabic ? 'arabicAlign' : ''">
                <div class="col-7 labelName" [ngClass]="isArabic ? 'arabicLabelAlign' : ''">
                    <span *ngIf="!isArabic">Answered</span>
                    <span *ngIf="isArabic">تم الإجابة</span>
                </div>
                <div class="col-5 numbers" [ngClass]="isArabic ? 'arabicNumberAlign' : ''">
                    <div class="innerBox">
                        <span>{{progressDetails?.totalAnswers}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 mainBox">
            <div class="row mainInnerBox" [ngClass]="isArabic ? 'arabicAlign' : ''">
                <div class="col-7 labelName" [ngClass]="isArabic ? 'arabicLabelAlign' : ''">
                    <span *ngIf="!isArabic">Progress</span>
                    <span *ngIf="isArabic">الإنجاز</span>
                </div>
                <div class="col-5 numbers" [ngClass]="isArabic ? 'arabicNumberAlign' : ''">
                    <div class="innerBox">
                        <span>{{progressDetails?.questionnaireProgress}}%</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="row mt-5 mb-5" [ngClass]="isArabic ? 'arabicAlign' : ''">
        <div class="col-4">
            <app-chart-doughnut [doughnutChartLabels]="isArabic ? assessmentArabicLabels : assessmentLabels"
                [doughnutChartData]="assessmentData" [backgroundColor]="assessmentBackgrnd"
                [borderColor]="assessmentBorder" [label]="assessmentTitle"
                [progressText]="progressText"></app-chart-doughnut>
        </div>
        <div class="col-8">
            <div class="row mt-3" *ngFor="let eachType of progressDetails?.totalEachTypeQuestions; let idx=index;"
                [ngClass]="isArabic ? 'arabicAlign' : ''">
                <label class="questionnaireName mb-1" [ngClass]="isArabic ? 'arabicAlign' : ''">
                    <span *ngIf="!isArabic">{{eachType.label}}</span>
                    <span *ngIf="isArabic">{{eachType.arabicLabel}}</span>
                </label>
                <div class="col-3" [ngClass]="isArabic ? 'rightAlign' : ''">
                    <div class="borderDiv" [ngClass]="isArabic ? 'borderArabicAlign' : ''">
                        <div><span class="quesNo">{{eachType.totalcount}}</span></div>
                        <div><span *ngIf="!isArabic" class="labelTxt">No. of Questions</span><span *ngIf="isArabic">عدد الأسئلة</span></div>
                    </div>
                </div>
                <div class="col-3" [ngClass]="isArabic ? 'rightAlign' : ''">
                    <div><span class="quesNo">{{eachType.answered}}</span></div>
                    <div><span *ngIf="!isArabic" class="labelTxt">Answered</span><span *ngIf="isArabic">تمت الإجابة</span>
                    </div>
                </div>
                <div class="col-3" [ngClass]="isArabic ? 'rightAlign' : ''">
                    <div><span class="quesNo">{{eachType.totalcount - eachType.answered}}</span></div>
                    <div><span *ngIf="!isArabic" class="labelTxt">Not Answered</span><span *ngIf="isArabic">لم تتم الإجابة</span></div>
                </div>
                <div class="col-3" [ngClass]="isArabic ? 'rightAlign' : ''">
                    <div><span class="quesNo">{{calculatePercentage(eachType.answered, eachType.totalcount)}}%</span>
                    </div>
                    <div><span *ngIf="!isArabic" class="labelTxt">Progress</span><span *ngIf="isArabic">التقدم</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
        <div class="col-4 quesChartDiv" *ngFor="let eachType of progressDetails?.totalEachTypeQuestions; let idx=index;"
            [ngClass]="(eachType.totalcount <= 0) ? 'nochartDiv' : ''">
            <app-chart-doughnut [doughnutChartLabels]="isArabic ? assessmentArabicLabels : assessmentLabels"
                [doughnutChartData]="[(eachType.totalcount - eachType.answered), eachType.answered]"
                [backgroundColor]="quesBackgrnd" [borderColor]="quesBorder" [label]="assessmentTitle"
                [progressText]="isArabic ? (calculatePercentage(eachType.answered, eachType.totalcount)+'% : ' + eachType.arabicLabel
        + ' متابعة إنجاز أسئلة القسم') : ('Progress of ' + eachType.label + ' : '+calculatePercentage(eachType.answered, eachType.totalcount)+'%')" *ngIf="eachType.totalcount > 0"></app-chart-doughnut>
            <div *ngIf="eachType.totalcount <= 0" class="noQuesDiv">
                <span *ngIf="!isArabic">No question available for {{eachType.label}}.</span>
                <span *ngIf="isArabic">لاتوجد أسئلة في القسم   {{eachType.arabicLabel}}</span>
                <!-- <span *ngIf="isArabic">.{{eachType.arabicLabel}} لا يوجد سؤال متاح ل</span> -->
            </div>

        </div>
    </div>

</div>